import {createStore} from "effector";

export const $importSubList = createStore([])

export const $addPosModal = createStore(false)

export const $showUpload = createStore(false)

export const $importUploadStatus = createStore(false)